module.exports = __webpack_public_path__ + "img/denmark-img.4fd5dd7.webp";